var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23828 1H1.41016C1.18364 1 1 1.18364 1 1.41016V2.36719H5.64844V1.41016C5.64844 1.18364 5.4648 1 5.23828 1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7939 4.90986C14.6665 4.83674 14.5096 4.83737 14.3828 4.91158L10.3242 7.28502V5.26562C10.3242 5.11868 10.2456 4.98297 10.1182 4.90986C9.99068 4.83674 9.83386 4.83737 9.70702 4.91158L5.64844 7.28502V3.1875H1V14.5898C1 14.8164 1.18364 15 1.41016 15H14.5898C14.8164 15 15 14.8164 15 14.5898V5.26562C15 5.11868 14.9214 4.98297 14.7939 4.90986ZM7.28906 12.1152C7.28906 12.3418 7.10542 12.5254 6.87891 12.5254H5.23828C5.01177 12.5254 4.82812 12.3418 4.82812 12.1152V10.4746C4.82812 10.2481 5.01177 10.0645 5.23828 10.0645H6.87891C7.10542 10.0645 7.28906 10.2481 7.28906 10.4746V12.1152ZM11.9648 12.1152C11.9648 12.3418 11.7812 12.5254 11.5547 12.5254H9.91406C9.68755 12.5254 9.50391 12.3418 9.50391 12.1152V10.4746C9.50391 10.2481 9.68755 10.0645 9.91406 10.0645H11.5547C11.7812 10.0645 11.9648 10.2481 11.9648 10.4746V12.1152Z",
    fill: "#8292E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.9777c0df.svg";
export { ForwardRef as ReactComponent };